import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, BellRing, Bookmark, CalendarDays, Mail, Users } from 'lucide-react';
import { PrivacyNote } from '../PrivacyNote';

/**
 * „Meine Events“ ohne Anmeldung (Entwurf 26.10.2026, Vorbild Crate & Barrel und Blinkit aus
 * Mobbin). Bis dahin leitete der Tab sofort auf die Anmeldeseite um: die Tab-Leiste verschwand,
 * und nirgends stand, was man vom Vormerken hat. Jetzt bleibt man im Tab und sieht es, aufgezählt
 * statt beworben. Alle vier Punkte gibt es tatsächlich (Mails für alle seit V179, Freunde seit V198).
 */
const VORTEILE = [
  { icon: <BellRing size={17} aria-hidden />, titel: 'Immer auf dem neuesten Stand', text: 'Bei neuem Datum, neuer Strecke oder Absage.' },
  { icon: <Bell size={17} aria-hidden />, titel: 'Anmeldung nicht verpassen', text: 'Benachrichtigung, sobald sie öffnet.' },
  { icon: <CalendarDays size={17} aria-hidden />, titel: 'Saison planen', text: 'Deine vorgemerkten Events im zeitlichen Ablauf, für die perfekte Vorbereitung.' },
  { icon: <Users size={17} aria-hidden />, titel: 'Mit Freunden fahren', text: 'Sieh, was deine Freunde vorhaben.' },
];

const MiniCard: React.FC<{ an?: boolean }> = ({ an }) => (
  <div className={`meg-mini${an ? ' meg-mini--an' : ''}`} aria-hidden>
    <div className="meg-mini-bild" />
    <div className="meg-mini-zeile" />
    <div className="meg-mini-zeile meg-mini-zeile--kurz" />
    <span className="meg-mini-merker"><Bookmark size={12} fill={an ? 'currentColor' : 'none'} /></span>
  </div>
);

const MeineEventsGast: React.FC = () => (
  <section className="meg">
    <div className="meg-bild"><MiniCard /><MiniCard an /><MiniCard /></div>
    <h2 className="meg-titel">Behalte deine Events im Blick</h2>
    <ul className="meg-vorteile">
      {VORTEILE.map(v => (
        <li key={v.titel}>
          <span className="meg-icon">{v.icon}</span>
          <span className="meg-vorteil"><strong>{v.titel}</strong>{v.text}</span>
        </li>
      ))}
    </ul>
    <Link className="meg-knopf" to="/login" state={{ from: { pathname: '/favorites', search: '' } }}>
      <Mail size={18} aria-hidden />Mit E-Mail anmelden
    </Link>
    <p className="meg-hinweis">Kein Passwort. Wir schicken dir einen Code.</p>
    <div className="meg-datenschutz"><PrivacyNote /></div>
  </section>
);

export default MeineEventsGast;
